import { apiFetch } from "./client";
import type { Booking } from "./bookings";

export type Unit = {
  id: number;
  name: string;
  beschreibung: string | null;
  nur_pfadfinder: number;
};

export { ANREDEN, GRUPPENARTEN } from "./constants";

export type NewBookingPayload = {
  gruppenname: string;
  anrede: string;
  vorname: string;
  nachname: string;
  email: string;
  telefon: string;
  einheiten_ids: number[];
  check_in: string;
  check_out: string;
  check_in_time: string;
  check_out_time: string;
  gruppenart: string;
  adresse_strasse: string;
  adresse_plz: string;
  adresse_ort: string;
  adresse_land: string;
  bemerkung: string;
  is_intern?: boolean;
  /** Weglassen = Config-Default (ANZAHLUNG_BETRAG). */
  anzahlung_betrag?: number;
  nachreinigung_eur?: number;
};

export function fetchUnits(): Promise<Unit[]> {
  return apiFetch<Unit[]>("/api/units");
}

export function createBooking(data: NewBookingPayload, force = false): Promise<Booking> {
  return apiFetch<Booking>(`/api/bookings${force ? "?force=true" : ""}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
